import React from 'react';
import PropTypes from 'prop-types';

import getVideoBreadcrumbs from '../helpers/getVideoBreadcrumbs';

import useTitleWithAccountName from '../hooks/useTitleWithAccountName';

import VideosBreadCrumbs from './videosBreadCrumbs';
import VideosTopicHeader from './videosTopicHeader';
import VideoTopicContent from './videoTopicContent';

const VideosTopic = ({ followTopic, handleViewChange, topic, unfollowTopic, view = 'tile' }) => {
  const { name } = topic;

  useTitleWithAccountName(name);

  return (
    <>
      <VideosBreadCrumbs
        breadcrumbs={getVideoBreadcrumbs({
          breadcrumbs: topic.breadcrumbs,
          currentLocation: topic,
        })}
      />
      <VideosTopicHeader
        name={name}
        description={topic.description}
        isFollowed={topic.is_followed}
        picture={topic.cover_art}
        followTopic={followTopic}
        unfollowTopic={unfollowTopic}
      />
      <VideoTopicContent
        isExpanded={topic.is_expanded_only}
        content={!topic.is_expanded_only ? topic.content : topic.sections}
        onButtonGroupChanged={handleViewChange}
        view={view}
        onLoadMore={() => {}}
      />
    </>
  );
};

VideosTopic.propTypes = {
  topic: PropTypes.shape({}).isRequired,
  view: PropTypes.string,
};

export default React.memo(VideosTopic);
